import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  width: 75%;
  border: 0;
`;

export const SplitContainer = styled.div`
  width: 45%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  padding: 10px;
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const CardHeader = styled.div`
  text-align: center;
  font-weight: 600;
  margin-bottom: 0;
  background-color: #66d7d1;
  color: white;
  padding: 0.85rem;
  font-size: 0.9rem;
  font-family: "Raleway", sans-serif;
`;

export const CardBody = styled.div`
  /* ... */
`;

export const CardFooter = styled.div`
  border: 0;
  padding: 0;
  padding-top: 5rem;
`;

export const RegisterWrap = styled.div`
  a {
    font-size: 12px;
    color: #999;
    text-transform: uppercase;
    cursor: pointer;
    font-weight: bold;
    &:hover {
      color: #005580;
      text-decoration: underline;
    }
  }
`;

export const Form = styled.form`
  padding: 0 5%;
  padding-top: 5%;
`;

export const ButtonContianer = styled.div`
  margin-top: 40px;
  margin-left: 65%;
  @media only screen and (max-width: 767px) {
    margin-left: 0%;
  }
`;

export const CheckboxContainer = styled.div`
  position: relative;
  left: 50%;
`;
